import { Link } from "react-router-dom";
import { Button } from "../../component/ui/button";
import { Input } from "../../component/ui/input";
import { Label } from "../../component/ui/label";
import {
  composeValidators,
  email,
  renderField,
  required,
  validatePassword,
} from "../../helpers/form-validations";
import { Field, Form } from "react-final-form";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import OTPComponent from "../../component/login/otpComponent";
import { login } from "../../utils/util";
import GetEmail from "../../component/login/getEmail";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";

export const description =
  "A login page with two columns. The first column has the login form with email and password. There's a Forgot your password link and a link to sign up if you do not have an account. The second column has a cover image.";

export function Login() {
  const dispatch=useDispatch()
  const [showPassword, setShowPassword] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  //   const onSubmit = (values) => {
  //     console.log(values); // Handle form submission here
  //   };
  const [isResetPassword, setIsResetPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    // Save the isOTP state to localStorage whenever it changes

    localStorage.setItem("isOTPPage", isVerified);
  }, [isVerified]);

  const onSubmit = async (formData) => {
    dispatch(loaderSet(true))
    const loginPayload = {
      email: formData.email,
      password: formData.password,
    };

    console.log(
      "Email : ",
      loginPayload.email,
      "password : ",
      loginPayload.password
    );

    try {
      const response = await login(loginPayload);

      if (formData.email !== "") {
        localStorage.setItem("email", formData.email);
      }

      // Log the response to debug
      console.log("Login Response:", response);
      if (response && response?.code===200) {

        setIsVerified(true);
        dispatch(alertSuccess("OTP successfully sent to your Email"))
        localStorage.setItem("email", formData.email);
        localStorage.setItem("password", formData.password);
        dispatch(loaderSet(false))
      }
      else{
        dispatch(alertDanger(response?.message))
        dispatch(loaderSet(false))
      }
    } catch (error) {
      // Log error for debugging
      console.error("Error during login:", error);
      dispatch(alertDanger(error.message))
      dispatch(loaderSet(false))
      //   setFormErrors({ general: 'An error occurred during login. Please try again.' });
    }
  };

  const backToLoginPageFromOTPPage = () => {
    setIsVerified(false);
    setIsResetPassword(false);
    localStorage.setItem("email", null);
  };

  return (
    <>
      <div className="w-full grid h-[100vh]  lg:grid-cols-2 md:h-[100vh]  lg:h-[100vh] xl:h-[100vh] 2xl:h-[100vh]">
        {/* Left side image */}
        <div className="hidden bg-muted lg:block">
          {/* <Image src="/placeholder.svg" alt="Image" width="1920" height="1080" className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale" /> */}
        </div>

        {/* Right side login */}
        {!isVerified && !isResetPassword ? (
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className="flex  justify-center py-16 h-[100%] text-black ">
                  <div className="mx-auto flex flex-col w-full gap-6">
                    <div className=" flex justify-center items-center w-full">
                      <img src="/vasuki-logo.svg" className="w-56" />
                    </div>
                    <div className=" grid gap-2 pl-10 pr-10">
                      <h1 className="text-start text-[#0D215C] font-bold text-[30px] py-2">
                        LOGIN
                      </h1>
                      <div className="grid gap-2">
                        <Label
                          className="text-start text-[#0D215C] font-bold text-lg"
                          htmlFor="email"
                        >
                          Email
                        </Label>
                        <Field
                          id="email"
                          type="email"
                          name="email"
                          placeholder=" abc1234@gmail.com"
                          validate={composeValidators(required, email)}
                          component={renderField} // Correct usage of renderField
                          className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />
                      </div>
                      <div className=" relative grid gap-2">
                        <div className="flex items-center">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor="password"
                          >
                            Password
                          </Label>
                        </div>
                        <Field
                          id="password"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="*************"
                          validate={composeValidators(required)} // Use the updated validatePassword
                          component={renderField} // Reuse the same renderField component
                          className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />
                        <div
                          className="absolute h-15 top-11 -right-1 flex items-center px-4 cursor-pointer"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? (
                            <EyeNoneIcon className="h-5 w-5 text-black" />
                          ) : (
                            <EyeOpenIcon className="h-5 w-5 text-black" />
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between py-2  w-full">
                        <Button type="submit" className="w-[40%] bg-[#0D215C]">
                          Generate OTP
                        </Button>
                        <div
                          onClick={() => setIsResetPassword(true)}
                          to="/forgot-password"
                          className="ml-auto inline-block text-[#0D215C] text-md font-semibold underline cursor-pointer"
                        >
                          Forgot your password?
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          />
        ) : isResetPassword ? (
          <GetEmail onBack={backToLoginPageFromOTPPage} />
        ) : (
          <OTPComponent onBack={backToLoginPageFromOTPPage} />
        )}
      </div>
    </>
  );
}

export default Login;